import { useState, useEffect } from "react";
import "../styles/Projects.css";
import ProjectDisplay from "./ProjectDisplay";

function Projects() {
  const [selectedTab, setSelectedTab] = useState("Current Projects");
  const [selectedProject, setSelectedProject] = useState("");

  const ProjectTabs = [
    { name: "Current Projects" },
    { name: "Completed Projects" },
    // { name: "Planned Projects" },
    // { name: "Project Map" },
  ];

  const currentProjects = [
    {
      index: 1,
      name: "Granary Park Phase 3",
      images: [
        "../assets/projects/current/Granary-ph3-before.png",
        "../assets/projects/current/Granary-ph3-after.png",
      ],
    },
    {
      index: 2,
      name: "Madeira Phase 3",
      images: [
        "../assets/projects/current/Madeira-ph3-before.png",
        "../assets/projects/current/Madeira-ph3-after.png",
      ],
    },
    {
      index: 3,
      name: "Parcel 61",
      images: [
        "../assets/projects/current/Reinhold61-before.png",
        "../assets/projects/current/Reinhold61-after.png",
      ],
    },
    {
      index: 4,
      name: "Trailmark 12",
      images: [
        "../assets/projects/current/Trailmark-12-before.png",
        "../assets/projects/current/Trailmark-12-after.png",
      ],
    },
    {
      index: 5,
      name: "Trailmark 13",
      images: [
        "../assets/projects/current/Trailmark13-before.png",
        "../assets/projects/current/Trailmark13-after.png",
      ],
    },
  ];

  const completedProjects = [
    {
      index: 1,
      name: "Creekview Trail 1&2",
      images: [
        "../assets/projects/completed/Creekview-1-2-before.png",
        "../assets/projects/completed/Creekview-1-2-after.png",
      ],
    },
    {
      index: 2,
      name: "Creekview Trail 5",
      images: [
        "../assets/projects/completed/Creekview-5-before.png",
        "../assets/projects/completed/Creekview-5-after.png",
      ],
    },
    {
      index: 3,
      name: "Granary Park Phase 2",
      images: [
        "../assets/projects/completed/Granary-ph2-before.png",
        "../assets/projects/completed/Granary-ph2-after.png",
      ],
    },
    {
      index: 4,
      name: "Grand Oaks",
      images: [
        "../assets/projects/completed/Grandoaks-before.png",
        "../assets/projects/completed/Grandoaks-after.png",
      ],
    },
    {
      index: 5,
      name: "McGirts Creek",
      images: [
        "../assets/projects/completed/Mcgirts-creek-before.png",
        "../assets/projects/completed/Mcgirts-creek-after.png",
      ],
    },
  ];

  const handleClick = (item) => {
    setSelectedTab(item.name);
  };

  // Update selectedProject based on the selectedTab
  useEffect(() => {
    if (selectedTab === "Current Projects") {
      setSelectedProject(currentProjects[0].name); // Set to first project's name
    } else if (selectedTab === "Completed Projects") {
      setSelectedProject(completedProjects[0].name); // Set to first project's name
    }
  }, [selectedTab]);

  return (
    <>
      <div className="project-container">
        <div className="project-content">
          <div className="project-tabs">
            {ProjectTabs.map((item, index) => (
              <h1
                key={index}
                className={
                  selectedTab === item.name ? "tab-title active" : "tab-title"
                }
                onClick={() => handleClick(item)}
              >
                {item.name}
              </h1>
            ))}
          </div>

          <div className="photo-content">
            {/* Current Projects */}
            {selectedTab === "Current Projects" && (
              <ProjectDisplay
                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}
                projectItems={currentProjects}
              />
            )}

            {selectedTab === "Completed Projects" && (
              <ProjectDisplay
                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}
                projectItems={completedProjects}
              />
            )}
            {selectedTab === "Project Map" && <h1> Map</h1>}
          </div>
        </div>
      </div>
    </>
  );
}

export default Projects;
